import angular from "angular";

angular
    .module('app')
    .component('uploadImage', {
        template: require('./upload-image.html'),
        controller: ['Upload', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(Upload) {

    let $ctrl = this;
    $ctrl.croppedImage = null;
    $ctrl.image = null;
    $ctrl.invalidImg = null;

    $ctrl.save = function () {
        $ctrl.close({
            $value: $ctrl.image
        });
    };

}
